import {
  getWorkHomeObjectHref,
  WORK_CHAT_HOME_PATH,
  type ObjectWorkspaceRoute,
} from '@heidi/agents/contracts';
import { atom } from 'jotai';

export { shouldHoldObjectWorkspaceNavigation } from '@heidi/agents/contracts';

export type WorkHomeStateNavigator = (href: string) => Promise<unknown>;

interface NavigateToWorkHomeStateArgs {
  route: ObjectWorkspaceRoute | null;
  reset: () => void;
  navigate: WorkHomeStateNavigator;
  /** True when the owner will run `reset` itself if the navigation proceeds. */
  deferReset?: (href: string) => boolean;
}

export interface WorkHomeObjectEntryGate {
  /** True when the discard guard will hold `href`; the page then resets only
   *  if the user confirms, so Cancel leaves the composer as it was. */
  deferResetIfHeld: (href: string) => boolean;
}

/** Published by the Work Home page while its discard guard is mounted. */
export const workHomeObjectEntryGateAtom = atom<WorkHomeObjectEntryGate | null>(null);

export const getVisitObjectWorkspaceRoute = (
  sessionId: string
): ObjectWorkspaceRoute => ({ kind: 'visit', id: sessionId });

export const getPatientObjectWorkspaceRoute = ({
  patientId,
  sourceSessionId,
}: {
  patientId?: string;
  sourceSessionId?: string;
}): ObjectWorkspaceRoute | null => {
  const id = patientId ?? sourceSessionId;
  if (!id) return null;
  return { kind: 'patient', id, ...(sourceSessionId ? { sourceSessionId } : {}) };
};

/** Reset local presentation first, then request one URL-owned Home identity. */
export const navigateToWorkHomeState = ({
  route,
  reset,
  navigate,
  deferReset,
}: NavigateToWorkHomeStateArgs): Promise<unknown> => {
  const href = route ? getWorkHomeObjectHref(route) : WORK_CHAT_HOME_PATH;
  if (!deferReset?.(href)) reset();
  return navigate(href);
};
